// function adjustFullHeight() {
//     const mainVisual = document.querySelector('.main-first-visual');
//     if (mainVisual) {
//       mainVisual.style.height = `${window.innerHeight}px`;
//     }
//   }

//   // 初期設定
//   adjustFullHeight();

//   // ウィンドウサイズ変更時に再調整
//   window.addEventListener('resize', adjustFullHeight);

// function adjustFullHeight() {
//     const mainVisual = document.querySelector('.main-first-visual');
//     if (mainVisual) {
//       // ヘッダーの高さを設定（画面幅に応じて変化）
//       const headerHeight = window.innerWidth < 990 ? 64 : 82.19;
      
//       // 表示可能な高さを計算
//       const viewHeight = window.innerHeight - headerHeight;

//       // 高さを適用
//       mainVisual.style.height = `${viewHeight}px`;
//     }
//   }

//   // 初期設定
//   adjustFullHeight();

//   // ウィンドウサイズ変更時に再調整
//   window.addEventListener('resize', adjustFullHeight);

window.FanclubCartLimit = {
  maxQuantity: 1,
  pendingCart: null,
  locks: new Set(),

  errorMessage() {
    const template = window.cartStrings?.quantityError || '';
    return template.replace('[quantity]', String(this.maxQuantity));
  },

  lock(id) {
    const key = String(id || '');
    if (!key || this.locks.has(key)) return false;
    this.locks.add(key);
    return true;
  },

  unlock(id) {
    this.locks.delete(String(id || ''));
  },

  fetchCart() {
    if (!this.pendingCart) {
      const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      this.pendingCart = fetch(`${cartUrl}.js`)
        .then((response) => response.json())
        .finally(() => {
          this.pendingCart = null;
        });
    }
    return this.pendingCart;
  },

  quantityForProduct(cart, productId) {
    const id = Number(productId);
    if (!id || !cart?.items) return 0;
    return cart.items.reduce((sum, item) => (item.product_id === id ? sum + item.quantity : sum), 0);
  },

  quantityForVariant(cart, variantId) {
    const id = Number(variantId);
    if (!id || !cart?.items) return 0;
    return cart.items.reduce((sum, item) => (item.variant_id === id || item.id === id ? sum + item.quantity : sum), 0);
  },

  async canAdd({ productId, variantId, quantity = 1 } = {}) {
    const cart = await this.fetchCart();
    const current = productId
      ? this.quantityForProduct(cart, productId)
      : this.quantityForVariant(cart, variantId);
    return current + Number(quantity || 1) <= this.maxQuantity;
  },
};

document.addEventListener('DOMContentLoaded', () => {
    const images = document.querySelectorAll('.preload');
    const mainVisual = document.querySelector('.main-first-visual');

    let imagesLoaded = 0;

    // 画像がロードされるまで待機
    images.forEach((img) => {
      img.onload = () => {
        imagesLoaded++;
        if (imagesLoaded === images.length) {
          mainVisual.classList.add('loaded'); // アニメーション開始クラスを追加
        }
      };

      // 画像がキャッシュ済みの場合にもイベントを強制発火
      if (img.complete) {
        img.onload();
      }
    });
  });